module.exports = __webpack_public_path__ + "img/funky-essex.39c13e4a.png";